export const POLICY_PRINT_COLUMNS = [
  { key: "status", label: "Status" },
  { key: "policyNumber", label: "Broj police" },
  { key: "clientName", label: "Ugovaratelj" },
  { key: "startingDate", label: "Datum produženja" },
  { key: "insuranceCompany", label: "Osiguravajuća kuća" },
  { key: "insuranceType", label: "Vrsta osiguranja" },
  { key: "price", label: "Premija" },
  { key: "phoneNumber", label: "Broj telefona" },
  { key: "location", label: "Prodajno mjesto" },
  { key: "partner", label: "Partner" },
  { key: "remark", label: "Napomena" },
];

export const PRINT_COLUMNS_STORAGE_KEY = "policyPrintColumns";

const ALL_COLUMN_KEYS = POLICY_PRINT_COLUMNS.map((c) => c.key);

export function getSelectedPrintColumnKeys() {
  try {
    const raw = localStorage.getItem(PRINT_COLUMNS_STORAGE_KEY);
    if (!raw) return ALL_COLUMN_KEYS;
    const parsed = JSON.parse(raw);
    const valid = parsed.filter((key) => ALL_COLUMN_KEYS.includes(key));
    return valid.length ? valid : ALL_COLUMN_KEYS;
  } catch {
    return ALL_COLUMN_KEYS;
  }
}

export function saveSelectedPrintColumnKeys(keys) {
  localStorage.setItem(PRINT_COLUMNS_STORAGE_KEY, JSON.stringify(keys));
}
